<template>
    <Head
        ><title>{{ t("consent.ai.pageTitle") }}</title></Head
    >
    <div class="flex flex-col min-h-screen overflow-y-auto h-screen bg-surface text-ink safe-area-top">
        <div class="fade-in grow justify-center gap-5 md:gap-10 flex flex-col items-center py-4 md:py-10">
            <div class="flex flex-col gap-4 justify-around text-center max-w-sm mx-auto px-4">
                <div class="flex flex-col pb-5 justify-center">
                    <img :src="Logo" :alt="t('common.valenceLogoAlt')" class="mx-auto h-16 w-auto" />
                </div>
            </div>
            <div class="flex flex-col gap-4 items-center max-w-md w-full px-4">
                <div class="text-center mb-2">
                    <h2 class="title-body mb-2">{{ t("consent.ai.heading") }}</h2>
                    <p class="body-small text-ink-muted">{{ t("consent.ai.subtitle") }}</p>
                </div>

                <BaseCard theme="muted" class="max-h-80 overflow-y-auto text-left">
                    <MarkdownText class="*:body *:text-ink-muted [&_p+p]:mt-3 [&_a]:underline" :text="disclosure_content" />
                </BaseCard>

                <BaseCheckbox v-model="consent" shape="square" class="body-small text-control-label justify-center">
                    {{ t("consent.ai.checkboxLabel") }}
                </BaseCheckbox>

                <BaseNotification v-if="error" theme="error" hide-dismiss class="w-full" :text="error.message" />
                <LoadingSpinner v-if="isFetching" class="w-10 h-10" />
                <BaseButton v-else theme="primary" data-testid="ai-consent-continue" class="w-full" :disabled="!consent" @click="acceptConsent">
                    {{ t("consent.ai.continue") }}
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Head } from "@inertiajs/vue3";
import Logo from "~img/color-logo.svg";
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";
import BaseCheckbox from "~vue/components/form/BaseCheckbox.vue";
import { useStatusBar } from "~vue/composables/useStatusBar";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useStatusBar();

const props = defineProps({
    next_url: { type: String, default: "/" },
    disclosure_content: { type: String, default: "" },
    terms_document_id: { type: String, required: true },
});

const consent = ref(false);

const { data, error, execute, isFetching } = useFetch("/accounts/ai-consent/", { immediate: false })
    .post(() => ({ consent: consent.value, terms_document_id: props.terms_document_id, next: props.next_url }))
    .json();

async function acceptConsent() {
    if (!consent.value) {
        return;
    }
    await execute();
    if (!error.value) {
        globalThis.location.href = data.value?.redirect ?? props.next_url;
    }
}
</script>
